import {
  //   Bathroom,
  //   Wc,
  BathtubOutlined,
  HelpOutline,
} from "@mui/icons-material";

const ICON_MAP = {
  // Bathroom Types
  attached: BathtubOutlined,
  common: BathtubOutlined,
};

export const BathroomOutlinedIcon = ({ iconKey, ...props }) => {
  const IconComponent = ICON_MAP[iconKey] || HelpOutline;
  return <IconComponent fontSize="inherit" {...props} />;
};
